import React from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import Loading from './Loading'
import { useIsAuthorized } from '../lib/auth0'

const RequireAuth: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { isLoading, isAuthenticated, isAuthorized, error } = useIsAuthorized()
  const location = useLocation()

  if (isLoading) {
    return <Loading />
  }

  if (!isAuthenticated || error) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (!isAuthorized) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />
  }

  return children
}

export default RequireAuth
